import app from '../../vue2.app.js'
import customConfig from '../../vue2.conf.json'
import defaultconfig from './conf.json'
import "./style/normalize.scss";
import "./style/base.scss";
import "./style/antoverlay.scss";

app.render({
    ...defaultconfig,
    ...customConfig
})